import React from "react";
const AboutMySubscription = () => {
  return (
    <div className="p-4 lg:p-6">
      <div className="space-y-8">
        <div>
         <h2 className="text-xl lg:text-2xl font-semibold text-[#454545] mb-6">
            Key Highlights
          </h2>
          <ul className="space-y-3 font-normal text-base lg:text-base text-[#222222] list-disc pl-6">
            <li>Daily trading signals</li>
            <li>Independent Trading Strategy</li>
            <li>Real-Time Trade Ideas</li>
            <li>Doubt Solving Sessions</li>
          </ul>
        </div>

        <div>
        <h2 className="text-xl lg:text-2xl font-semibold text-[#454545] mb-6">
            Trading Strategy Details
          </h2>
            <ol className="space-y-4 text-base lg:text-base text-[#222222] list-decimal pl-6">
            <li className="leading-relaxed">
              <span className="font-medium">Daily Trading Signals:</span>{" "}
              Receive 5-8 expertly curated trading signals daily. Our focus
              encompasses key market movers such as Nifty, BankNifty, FinNifty,
              and Sensex, ensuring a comprehensive market approach.
            </li>
            <li className="leading-relaxed">
              <span className="font-medium">
                BTST (Buy Today, Sell Tomorrow) Advantage:
              </span>{" "}
              Beyond intraday, harness the power of BTST calls, optimized for
              short-term trading opportunities.
            </li>
            <li className="leading-relaxed">
              <span className="font-medium">Live Trading Sessions:</span> Engage
              in interactive sessions, designed to demystify trading
              complexities, clarify doubts, and strengthen your trading
              foundation.
            </li>
            <li className="leading-relaxed">
              <span className="font-medium">Real-Time Trade Ideas:</span> Our
              actionable trade ideas are not just theoretical but rooted in
              real-time market dynamics, ensuring you're always a step ahead.
            </li>
            <li className="leading-relaxed">
              <span className="font-medium">Optimized Risk-Reward:</span>{" "}
              Benefit from signals boasting an impressive hit rate, balanced
              with optimal risk-reward ratios, ensuring your trades align with
              profitability and security.
            </li>
            <li className="leading-relaxed">
              <span className="font-medium">Verified Track Record:</span> Trust,
              backed by results. Our past performance stands as a testament to
              our expertise, dedication, and analytical prowess.
            </li>
            <li className="leading-relaxed">
              <span className="font-medium">Thriving Trading Community:</span>{" "}
              Join a vibrant community of traders. Engage, learn, and grow in an
              environment that fosters knowledge exchange and mutual support.
              Step into a realm of trading where every signal, strategy, and
              session is designed with your success at its core. Together, let's
              navigate the market's intricacies, transforming challenges into
              opportunities.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default AboutMySubscription;
